import React from "react";
import "./Hydrate.css";
import { useTranslation } from "react-i18next";

interface HydrateProps {
  message?: string;
}

const Hydrate: React.FC<HydrateProps> = ({ message }): React.JSX.Element => {
  const { t } = useTranslation(); // Use useTranslation hook

  return (
    <div className="gif">
      <img src="/img/water-bottle.gif" alt="Hydrate GIF" width={596} height={596} />
      <div className="text-2">{t(`hydrate.${message}`)}</div>
    </div>
  );
};

export default Hydrate;